import React from "react";
import i18n from "../i18n";
import constant from "../config/index.json";
import { isEU } from "./storeUtils";
import { RETURN_CENTER_ADDRESS_KEY } from "../constants/returns.const";
import { EMAIL_REGEX } from "../constants/common.const";


/* eslint-disable no-useless-escape */
function getCookieByName(name) {
  name = `${name}=`;
  const ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    const c = ca[i]?.trim();
    if (c.indexOf(name) === 0) return c.substring(name.length, c.length);
  }
  return "";
}
export const escapeSpecialChars = (arg1) => {
  if (arg1 === null || arg1 === "") {
    return "";
  }
  return arg1
    .replace(/[\\]/g, "\\\\")
    .replace(/'/g, "\\'")
    .replace(/[\"]/g, '\\"')
    .replace(/[\/]/g, "\\/")
    .replace(/[\b]/g, "\\b")
    .replace(/[\f]/g, "\\f")
    .replace(/[\n]/g, "\\n")
    .replace(/[\r]/g, "\\r")
    .replace(/[\t]/g, "\\t")
    .replace(/&amp;/g, "&");
};
export const removeHTMLTags = (htmlString) => {
  const regX = /(<([^>]+)>)/gi;
  return htmlString.replace(regX, "");
};

export const getRouteFromBrowser = () => {
  if (typeof window === "undefined") {
    return "";
  }

  const path = window?.location?.pathname?.toLowerCase() || "";
  const knownRoutes = ["place-order", "order-history", "my-account", "cto"];
  const matchedRoute = knownRoutes.find((route) => path.includes(route));

  if (matchedRoute) {
    return matchedRoute;
  }

  const segments = path.split("/").filter(Boolean);
  return segments[segments.length - 1] || "";
};

export const canDisplayAddress = (address, orgID) => {
  const route = getRouteFromBrowser();
  if (!orgID) return false;
  if (orgID !== '116' && ['order', 'order-history', 'my-account', 'return', 'return-history'].includes(route)) {
    // Case 1: display_for_sales = Y, list_to_public = Y → show everywhere
    if (!isFalseValue(address?.["display-for-sales"]) && !isFalseValue(address?.["list-to-public"]) && address["org-id"] === orgID) {
      return true;
    }

    // Case 2: display_for_sales = N, list_to_public = N → show nowhere
    if (isFalseValue(address?.["display-for-sales"]) && isFalseValue(address?.["list-to-public"]) && address["org-id"] === orgID) {
      return false;
    }

    // Case 3: display_for_sales = N, list_to_public = Y → only returns modules
    if (isFalseValue(address?.["display-for-sales"]) && !isFalseValue(address?.["list-to-public"]) && address["org-id"] === orgID) {
      return ['return', 'return-history'].includes(route);
    }

    // Case 4: display_for_sales = Y, list_to_public = N → only place order modules nd my-account
    if (!isFalseValue(address?.["display-for-sales"]) && isFalseValue(address?.["list-to-public"]) && address["org-id"] === orgID) {
      return ['order', 'order-history', 'my-account'].includes(route);
    }
  } else if (!isFalseValue(address["list-to-public"]) && address["org-id"] === orgID) {
    return true;
  }

  return false;
};

export const canDisplayShiptoBillTOAddress = (address, orgID) => {
  const route = getRouteFromBrowser();
  if (!orgID || !address) return false;
  if (orgID !== '116' && !isEU() && ['order', 'order-history', 'my-account', 'return', 'return-history'].includes(route)) {
    // Case 1: display_for_sales = Y, list_to_public = Y → show everywhere
    if (!isFalseValue(address?.["display-for-sales"]) && !isFalseValue(address?.["list-to-public"]) && address["org-id"] === orgID) {
      return true;
    }

    // Case 2: display_for_sales = N, list_to_public = N → show nowhere
    if (isFalseValue(address?.["display-for-sales"]) && isFalseValue(address?.["list-to-public"]) && address["org-id"] === orgID) {
      return false;
    }

    // Case 3: display_for_sales = N, list_to_public = Y → only returns modules
    if (isFalseValue(address?.["display-for-sales"]) && !isFalseValue(address?.["list-to-public"]) && address["org-id"] === orgID) {
      return ['return', 'return-history'].includes(route);
    }

    // Case 4: display_for_sales = Y, list_to_public = N → only place order modules and my-account
    if (!isFalseValue(address?.["display-for-sales"]) && isFalseValue(address?.["list-to-public"]) && address["org-id"] === orgID) {
      return ['order', 'order-history', 'my-account'].includes(route);
    }
  } else if (!isFalseValue(address["list-to-public"]) && address["org-id"] === orgID && !isEU()) {
    return true;
  } else if (!isFalseValue(address["list-to-public"]) && isEU()) {
    return true;
  }

  return false;
};

export const isInvalid = (val) => !val || val === 'undefined' || val === 'null';

export const formatShippingBillingAddress = (data, orgID, currentOrderType = '') => {
  if (!data?.length) return [];

  return data
    .filter(({ address }) => canDisplayAddress(address, orgID))
    ?.map(({ address, self }) => {
      const components = [
        address["street-address"],
        address["extended-address"]?.trim(),
        address.locality,
        address.region,
        address["postal-code"],
      ].map((comp) => comp || "");

      return {
        title: components.filter(Boolean).join(" "),
        titleWithSeparator: components.join("|"),
        value: self.uri,
        dataValue: address.region,
        addressID: address["site-use-id"],
        status: address["site-use-status"],
        partnerLocationUUIDPK: address["partner-location-uuidpk"] || "",
        currentOrderType: !isInvalid(currentOrderType) ? currentOrderType : "",
      };
    });
};

export const formatOptions = (data, orgID) => {
  if (!data?.length) return [];

  return data
    .filter(
      ({ address }) =>
        !isFalseValue(address["list-to-public"]) && address["org-id"] === orgID
    )
    ?.map(({ address, self }) => {
      const components = [
        address["street-address"],
        address["extended-address"]?.trim(),
        address.locality,
        address.region,
        address["postal-code"],
      ].map((comp) => comp || "");

      return {
        title: components.filter(Boolean).join(" "),
        titleWithSeparator: components.join("|"),
        value: self.uri,
        dataValue: address.region,
        addressID: address["site-use-id"],
        status: address["site-use-status"],
        partnerLocationUUIDPK: address["partner-location-uuidpk"] || "",
      };
    });
};

export const formatDropdownOptionsForReturns = options => (
  Array.isArray(options)
    ? options
      .filter(option => option?.key != null && option?.value != null)
      .map(option => ({
        title: option.value,
        value: `${option.key}||${option.value}`,
      }))
    : []
);

// eslint-disable-next-line
export const validAddressCheck =
  /(?:P(?:(o|0)st(?:al)?)?[\.\-\s]*(?:(?:(O|0)(?:ffice)?[\.\-\s]*)?B(?:ox|in|\b|\d)|(o|0)(?:ffice|\b)(?:[-\s]*(#|\d))|code)|box[-\s\b]*\d)/i;

export default getCookieByName;

export function isLinkInArray(arr) {
  if (arr?.length) {
    let currentPath = window.location.pathname;
    currentPath = currentPath.substring(6);

    for (let i = 0; i < arr.length; i++) {
      if (arr[i] === currentPath) {
        return true;
      }
      if (arr[i]?.link === currentPath) {
        return true;
      }
      if (arr[i]["sub-menu"]) {
        for (let j = 0; j < arr[i]["sub-menu"].length; j++) {
          if (arr[i]["sub-menu"][j].link === currentPath) {
            return true;
          }
        }
      }
    }
    return false;
  }
  return false;
}

export const findProperty = (value, property, org, region, ppNotNull) => {
  if (!Array.isArray(value)) {
    return null;
  }
  let result = value?.find(
    (e) => e && typeof e === "object" && e["display-name"] === property
  );

  if (!result) return null;

  const val = result?.value;

  if (
    result?.name === constant?.product?.productHcpc &&
    Array.isArray(val) &&
    org &&
    region
  ) {
    result = val
      ?.map((item) => item.split(">"))
      ?.filter((parts) => parts[0] === org && parts[1] === region)
      ?.map((parts) => ({
        ...result,
        orgID: parts[0],
        region: parts[1],
        value: parts[2],
      }));
  }

  if (typeof val === "string") {
    const parts = val?.split(">");
    result = { ...result, value: parts[2] || parts[0] };
  }

  return result;
};

const historyStatusIncludes = [
  "pending",
  "invoiced",
  "shipped",
  "cancelled",
  "processing",
  "awaiting return",
  "backordered",
];
export const historyStatusIncludesCheck = (item) =>
  historyStatusIncludes?.includes(item?.toLowerCase())
    ? i18n.t(`common.historyStatus.${item?.toLowerCase()}`)
    : item;
const availabilityStatusIncludes = [
  "available",
  "limited",
  "outofstock",
  "discontinued",
  "limited stock - last buy",
  "not orderable",
  "awsl",
];
export const availabilityStatusIncludesCheck = (item) => {
  const status = item?.toLowerCase();

  if (availabilityStatusIncludes?.includes(status)) {
    return i18n.t(`common.availability.${status}`);
  } else if (
    status === "information not available at this time" ||
    status === "stock.info.not.available"
  ) {
    return i18n.t("common.availability.notAvailable");
  }

  return item;
};
export const publicRoute = [
  "/",
  "/reset-password",
  "/new-account",
  "/login",
  "/contact-us",
  "/help",
];

// Replace/Return Status Changes
const returnStatusIncludes = [
  "entered",
  "booked",
  "invoiced",
  "shipped",
  "closed",
  "cancelled",
  "awaitingfulfilment",
  "awaitingshipping",
  "awaitingreturn",
  "backordered",
  "awaiting_shipping",
  "awaiting_fulfillment",
];
export const returnStatusIncludesCheck = (item) =>
  returnStatusIncludes?.includes(item?.toLowerCase())
    ? i18n.t(`common.returnStatus.${item?.toLowerCase()}`)
    : item;

// convert a phone number to the (999) 999-9999 format
export const formatPhoneNumber = (phoneNumber, format) => {
  if (!phoneNumber) {
    return phoneNumber;
  }
  const digitsOnly = String(phoneNumber).replace(/\D/g, "").slice(0, PHONE_MAX_DIGITS);

  if (!digitsOnly) {
    return "";
  }

  if (!format) {
    return digitsOnly;
  }

  let formatted = "";
  let digitIndex = 0;

  for (let i = 0; i < format.length && digitIndex < digitsOnly.length; i++) {
    if (format[i] === "9") {
      formatted += digitsOnly[digitIndex];
      digitIndex++;
    } else {
      formatted += format[i];
    }
  }

  if (digitIndex < digitsOnly.length) {
    formatted += digitsOnly.slice(digitIndex);
  }

  return formatted;
};

export const parseCurrency = (str) => {
  // If it's already a pure number or numeric string, return it directly
  if (typeof str === "number") return str;
  if (/^-?\d+([.,]?\d+)?$/.test(str.trim())) {
    return parseFloat(str.replace(",", "."));
  }
  // remove any currencies coming from backend and get value
  const removeSymbols = str.replace(/[^\d.,-]/g, "").trim();
  // handle european scenario where . and , will be replaced
  const isEuropean =
    removeSymbols.match(/\d+\.\d{3},\d{2}$/) ||
    removeSymbols.match(/\d+,\d{2}$/);
  let value = removeSymbols;
  if (isEuropean) {
    value = removeSymbols.replace(/\./g, "").replace(/,/g, ".");
  } else {
    value = removeSymbols.replace(/,/g, "");
  }
  const num = parseFloat(value);
  return isNaN(num) ? null : num;
};

export const PHONE_MAX_DIGITS = 20;


export const getMaxDigitsForFormat = (customerPhoneFormat) => {
  if (!customerPhoneFormat) {
    return PHONE_MAX_DIGITS;
  }
  const placeholderCount = (customerPhoneFormat.match(/9/g) || []).length;
  return placeholderCount > 0 ? Math.min(placeholderCount, PHONE_MAX_DIGITS) : PHONE_MAX_DIGITS;
};

/**
 * Gets the translated phone validation error message
 * Returns a user-facing message without exposing internal field names
 * @returns {string} Translated validation error message
 */
export const getPhoneValidationError = () => {
  return i18n.t('common.validation.phoneInvalid', {
    defaultValue: `Phone number must contain only numbers and cannot exceed ${PHONE_MAX_DIGITS} digits`,
  });
};

// Deprecated: Use getPhoneValidationError() instead
export const PHONE_VALIDATION_ERROR =
  `Phone number must contain only numbers and cannot exceed ${PHONE_MAX_DIGITS} digits`;

const PHONE_FIELD_REGEX = /(phone|telephone)/i;
const PHONE_EXTENSION_FIELD_REGEX = /(ext|extension)/i;

export const isPhoneLikeField = (fieldName = "") =>
  PHONE_FIELD_REGEX.test(fieldName) &&
  !PHONE_EXTENSION_FIELD_REGEX.test(fieldName);

export const sanitizePhoneInput = (value = "") =>
  String(value).replace(/\D/g, "").slice(0, PHONE_MAX_DIGITS);

export const validatePhoneForSubmission = (
  value,
  { required = false, fieldName = "phone" } = {}
) => {
  if (value === null || value === undefined || value === "") {
    if (required) {
      throw new Error(getPhoneValidationError());
    }
    return "";
  }

  const valueString = String(value);
  if (!/^\d+$/.test(valueString) || valueString.length > PHONE_MAX_DIGITS) {
    throw new Error(getPhoneValidationError());
  }

  return valueString;
};

export const validatePhonePayload = (payload) => {
  if (!payload || typeof payload !== "object") {
    return;
  }

  if (Array.isArray(payload)) {
    payload.forEach((item) => validatePhonePayload(item));
    return;
  }

  Object.entries(payload).forEach(([key, value]) => {
    if (isPhoneLikeField(key) && (typeof value === "string" || typeof value === "number")) {
      validatePhoneForSubmission(sanitizePhoneInput(value), { required: false, fieldName: key });
      return;
    }

    if (value && typeof value === "object") {
      validatePhonePayload(value);
    }
  });
};

export const formattedCurrencyLocale = (amount, locale, currency) => {
  if (!amount || !locale || !currency) {
    return amount;
  }
  const updatedAmount = parseCurrency(amount);
  const formatted = new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
    currencyDisplay: "symbol",
  }).format(updatedAmount);
  const formattedCurrenyAmount = formatted.replace(
    /^-?[A-Z]{1,3}(?=[^\d]+)/,
    (match) => (match.startsWith("-") ? "-" : "")
  );
  return `${formattedCurrenyAmount} ${currency}`;
};

export const getFormattedPriceBreaks = (qty, amount, locale, currency) => {
  const qtyText = `> ${qty - 1}`;
  const paddedQtyText = qty - 1 === 0 ? qtyText.padEnd(8) : qtyText.padEnd(7);

  if (amount === 0) {
    return `${paddedQtyText} : ${" "}${formattedCurrencyLocale(
      "0.00",
      locale,
      currency
    )}`;
  }
  return `${paddedQtyText} : ${" "}${formattedCurrencyLocale(
    amount,
    locale,
    currency
  )}`;
};

export const highlightMatchingText = (text, query) => {
  if (!query || !text) return text;

  const regex = new RegExp(`(${query})`, "gi");
  const parts = text?.split(regex);

  return parts?.map((part, index) => {
    if (part?.toLowerCase()) {
      return (
        <span
          key={index}
          style={{
            fontWeight: part.toLowerCase() === query.toLowerCase() ? 700 : 500,
            fontFamily: "inherit",
          }}
        >
          {part}
        </span>
      );
    }
    return false;
  });
};

export const formatAddress = (address) => {
  if (!address) return { line1: "", line2: "" };

  const line1Parts = [
    address?.['street-address'],
    address?.['extended-address']?.trim()
  ]?.filter(Boolean);

  const line2Parts = [
    address?.locality,
    address?.region,
    address?.['postal-code']
  ]?.filter(Boolean);

  return {
    line1: line1Parts?.join(" "),
    line2: line2Parts?.join(" ")
  };
};

export const validateAlphanumeric = (value) => {
  if (!value) return "";

  let cleaned = value?.replace(/[^A-Za-z0-9 -]+/g, "");

  cleaned = cleaned?.replace(/^\s+/, "");

  return cleaned;
};

export const formatAmount = (amount, locale) => {
  const prefixToCurrency = { AU: 'AUD', NZ: 'NZD', EU: 'EUR' };

  for (const [prefix, currency] of Object.entries(prefixToCurrency)) {
    if (amount?.startsWith(prefix)) {
      const numericValue = amount?.slice(prefix?.length);
      return `${currency} ${numericValue}`;
    }
  }

  return locale?.toLowerCase() === 'fr_ca' ? `${amount} $` : `$${amount}`;
};

const ALLOWED_LOCALES = new Set([
  'en-US',
  'en-GB',
  'en-AU',
  'fr-CA',
  'fr-FR',
  'de-DE',
]);

export const getUserLocale = (language = '') => ALLOWED_LOCALES?.has(language) ? language : 'en-US';

export const parseAttentionMessage = (attentionMsg) => {
  if (!attentionMsg) return null;

  if (typeof attentionMsg !== 'string') return attentionMsg;

  const trimmed = attentionMsg?.trim();
  if (trimmed?.startsWith('{') || trimmed?.startsWith('[')) {
    try {
      return JSON.parse(attentionMsg);
    } catch (e) {
      return attentionMsg;
    }
  }

  return attentionMsg;
};

export const getGenericKeyResults = (response) => {
  if (!response) return [];

  if (Array.isArray(response)) return response;

  const groupResults = response?.data?.groups?.[0]?.results;
  if (Array.isArray(groupResults)) return groupResults;

  return Array.isArray(response?.data?.results)
    ? response.data.results
    : [];
};

export const getFlattenedGenericKeyResults = (response) => {
  if (!response) return [];

  const extractResults = (value) => {
    if (!value) return [];

    if (Array.isArray(value)) {
      return value.flatMap((item) => extractResults(item));
    }

    if (typeof value === 'object') {
      if (Array.isArray(value?.results)) {
        return value.results.flatMap((item) => extractResults(item));
      }

      if (Array.isArray(value?.data)) {
        return extractResults(value.data);
      }

      if (Array.isArray(value?.groups)) {
        return value.groups.flatMap((group) => extractResults(group));
      }

      if (value?.key && value?.value !== undefined) {
        return [value];
      }

      return Object.values(value).flatMap((item) => extractResults(item));
    }

    return [];
  };

  return extractResults(response);
};

export const getResultValueByKey = (result, key) => {
  const normalizedResults = getFlattenedGenericKeyResults(result);

  return (
    normalizedResults.find(item => item?.key === key)?.value || ''
  );
};

export const getTranslatedLabel = (value, isApi = false) => {
  if (typeof value !== 'string') return value ?? '';

  const [primary = '', secondary = ''] =
    value?.split('||')?.map(v => v?.trim()) ?? [];

  return isApi ? primary : (secondary || primary);
};

export const getTranslatedLabelForItemSummary = (value) => {
  if (typeof value !== 'string') return value ?? '';

  const [key = '', val = ''] =
    value?.split('||')?.map(v => v?.trim()) ?? [];

  return val || key;
};

/**
 * Generates phone mask format based on customer phone format
 * @param {string} customerPhoneFormat - Phone format from Redux state (e.g., "(999) 999-9999")
 * @param {number} maxDigits - Maximum phone digits allowed (default: derived from format, e.g. 10 for (xx) xxxx-xxxx)
 * @returns {string} Formatted mask string, truncated/padded to respect maxDigits
 */
export const getPhoneMaskFormat = (
  customerPhoneFormat,
  maxDigits = getMaxDigitsForFormat(customerPhoneFormat)
) => {
  const unMask = (number) =>
    number ? number.replace(/[^\d]/g, '') : '';

  if (!customerPhoneFormat) {
    return '9'.repeat(maxDigits);
  }

  const baseDigits = unMask(customerPhoneFormat).length;

  // If the format itself already has more digit placeholders than the
  // allowed maxDigits, truncate the format so it never exceeds the limit.
  if (baseDigits > maxDigits) {
    let digitCount = 0;
    let truncated = '';
    for (const char of customerPhoneFormat) {
      if (char === '9') {
        if (digitCount >= maxDigits) break;
        digitCount++;
      }
      truncated += char;
    }
    return truncated;
  }

  if (baseDigits === maxDigits) {
    return customerPhoneFormat;
  }

  return `${customerPhoneFormat}${'9'.repeat(maxDigits - baseDigits)}`;
};

/**
 * Handles phone input keydown events to restrict input to digits only
 * Allows standard keyboard shortcuts (copy, paste, etc.) and navigation keys
 * @param {KeyboardEvent} event - The keyboard event
 */
export const handlePhoneKeyDown = (event) => {
  const key = event?.key;
  const isShortcut =
    (event.ctrlKey || event.metaKey) &&
    ['a', 'c', 'v', 'x'].includes((key || '').toLowerCase());

  if (
    isShortcut ||
    [
      'Backspace',
      'Delete',
      'Tab',
      'Escape',
      'Enter',
      'ArrowLeft',
      'ArrowRight',
      'ArrowUp',
      'ArrowDown',
      'Home',
      'End',
    ].includes(key)
  ) {
    return;
  }

  if (!/^\d$/.test(key)) {
    event.preventDefault();
  }
};

export const formatAddressInTwoLines = (text = "") => {
  if (!text) return text;

  const parts = text?.split(",")?.map(p => p.trim());
  if (parts.length <= 2) {
    return parts.join("<br/>");
  }

  const mid = Math.ceil(parts?.length / 2);
  return (
    parts?.slice(0, mid).join(", ") +
    "<br/>" +
    parts?.slice(mid).join(", ")
  );
};


export const splitPriceBreak = (formattedString) => {
  if (!formattedString || typeof formattedString !== 'string') {
    return { qty: '', amount: '' };
  }

  const parts = formattedString?.split(':');
  return {
    qty: parts[0]?.trim() || '',
    amount: parts[1]?.trim() || ''
  };
};

export const successMessage = (entity, action) =>
  i18n.t("common.messages.actionSuccess", {
    entity: i18n.t(`common.entities.${entity}`),
    action: i18n.t(`common.actions.${action}`),
  });

export const transformConfig = (configArray = []) => {
  const result = {};

  configArray.forEach((item) => {
    const fieldName = item["configuration-field"];

    result[fieldName] = {
      countryEnabled: item["is-country-code-enabled"] === constant.enabled,
      orgEnabled: item["is-org-id-enabled"] === constant.enabled,
      mandatory: item["is-mandatory-status"] === constant.enabled,
    };
  });

  return result;
};

export const excludeKeys = (obj = {}, keys = []) =>
  Object.fromEntries(
    Object.entries(obj).filter(([key]) => !keys.includes(key))
  );

export const toCamelCaseStatus = (status = "") => {
  if (typeof status !== "string") {
    return "";
  }

  const normalizedStatus = status?.trim();

  return normalizedStatus
    ?.toLowerCase()
    ?.replace(/[_\s]+(.)?/g, (_, char) => (char ? char?.toUpperCase() : ""));
};

export const splitCurrency = (value) => {
  if (!value) {
    return { currency: '', amount: '' };
  }

  const parts = value.trim().split(' ');
  if (parts.length < 2) {
    return { currency: '', amount: value };
  }
  return {
    currency: parts[0],
    amount: parts[1],
  };
};

export const isFalseValue = (value) => {
  return (
    value == null ||
    value.toString().trim() === "" ||
    value.toString().trim().toUpperCase() === "N"
  );
};

export const getAddressByPartnerLocationUUID = (
  addresses = [],
  partnerLocationUUIDPK
) =>
  addresses?.find(
    ({ partnerLocationUUIDPK: uuid }) =>
      String(uuid) === String(partnerLocationUUIDPK)
  );

export const getReturnCenterInfo = () => {
  return JSON.parse(
    sessionStorage.getItem(RETURN_CENTER_ADDRESS_KEY) || '{}'
  );
};

export const getPreferredLanguages = () => {
  const returnCenterInfo = getReturnCenterInfo();
  return returnCenterInfo?.data?.['preferred-languages'] || [];
};

export const isResMedDomainUser = (email = "") => {
  const domain = email?.split("@")[1]?.toLowerCase();
  return constant.resmedDomains?.includes(domain);
};

export const getDropdownKeyForPayload = (value) => {
  if (typeof value !== 'string') return value ?? '';

  return value?.split('||')[0]?.trim();
};


export const isValidEmailAddress = email =>
  typeof email === 'string' &&
  email.trim() !== '' &&
  EMAIL_REGEX.test(email);

export const getAccountPermissions = (userPermissions, accountNumber) => {
  let parsedPermissions = [];

  try {
    parsedPermissions = JSON.parse(userPermissions || '[]');
  } catch {
    parsedPermissions = [];
  }

  const currentAccountNumber = String(accountNumber);

  return {
    matchedPermissions: parsedPermissions.find(
      ({ XREF_CUSTOMER_NUM }) =>
        String(XREF_CUSTOMER_NUM) === currentAccountNumber
    ),
    otherPermissions: parsedPermissions.filter(
      ({ XREF_CUSTOMER_NUM }) =>
        String(XREF_CUSTOMER_NUM) !== currentAccountNumber
    ),
  };
};